import React, { useState } from "react";
import { useSelector } from "react-redux";
import { mainFeatures } from "../constants";
import { useLocation, useNavigate } from "react-router-dom";
import { settings, stars, support } from "../assets";
import Missions from "./Missions";
import OverlayUpgrade from "./OverlayUpgrade";
import OverlayRedirect from "./OverlayRedirect";
import ModalMissionChecklist from "./modals/ModalMissionChecklist";

const SideBar = ({ active, mission_, interceptFunc = false }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const currentPathname = location.pathname;
  const user = JSON.parse(localStorage.getItem("user_info"));
  const mission = mission_ || JSON.parse(localStorage.getItem("mission"));
  const firstLogin = user.is_first_login;
  const [openOverlay, setOpenOverlay] = useState(false);
  const [openMission, setOpenMission] = useState(firstLogin && !mission);
  const [loc, setLoc] = useState("");
  const [showPopup, setShowPopup] = useState(false);
  const isOpen_ = useSelector((state) => state.changeSideBarReducer.isOpen);
  let package_;
  let isFree;
  package_ = user.package.slug;
  isFree = package_.toLowerCase().includes("free");
  return (
    <div
      className={`hidden md:flex md:flex-col ${
        isOpen_ ? "w-1/4" : ""
      } px-5 items-start justify-between bg-white h-[90vh] border-0 border-r-2 border-r-gray-200 py-7`}
    >
      {firstLogin && openMission && (
        <ModalMissionChecklist setOpenMission={setOpenMission} />
      )}
      {openOverlay |
      (package_.includes("free") && currentPathname.includes("/analytics")) ? (
        <OverlayUpgrade setOpenOverlay={setOpenOverlay} />
      ) : null}
      {showPopup && <OverlayRedirect setOpenOverlay={setShowPopup} loc={loc} />}
      <div className="flex flex-col gap-5 w-full">
        {mainFeatures.map((val, ind) => (
          <div
            className={`flex flex-row relative w-full text-[14px] items-center py-2 px-3 rounded-lg cursor-pointer hover:font-bold group ${
              val.id.toLowerCase() == active
                ? "bg-gray-200 font-bold"
                : "hover:bg-gray-100"
            }`}
            onClick={() => {
              if (ind == 3 && isFree) {
                setOpenOverlay(true);
              } else {
                if (interceptFunc) {
                  setLoc(val.path);
                  setShowPopup(true);
                } else {
                  navigate(val.path);
                }
              }
            }}
            key={ind}
          >
            <div className="flex flex-col relative">
              <img src={val.icon} className="w-[30px]" />
              {ind == 3 && isFree ? (
                <img
                  src={stars}
                  alt=""
                  className="absolute w-3 h-3 top-0 right-0"
                />
              ) : null}
            </div>

            <div
              className={`overflow-hidden transition-all font-sans text-black ${
                isOpen_ ? "ml-3" : "w-0 h-0"
              }`}
            >
              {val.id}
            </div>
            {!isOpen_ && (
              <div className="absolute left-full px-2 text-center bg-gray-100 py-2 rounded-lg transition-all -translate-x-52 opacity-0 group-hover:opacity-100 group-hover:translate-x-0  ml-3 whitespace-nowrap z-[999] text-black">
                {val.id}
              </div>
            )}
          </div>
        ))}
      </div>

      <div className="flex flex-col w-full gap-3 text-[14px]">
        {mission && <Missions isOpen_={isOpen_} mission={mission} />}
        <hr className="bg-black w-full" />
        <div
          className={`flex flex-row w-full items-center py-2 px-3 rounded-lg cursor-pointer hover:font-bold ${
            "setting" == active ? "bg-gray-200 font-bold" : "hover:bg-gray-100"
          }`}
          onClick={() => {
            if (interceptFunc) {
              setShowPopup(true);
              setLoc("/settings");
            } else {
              navigate("/settings");
            }
          }}
        >
          <img src={settings} className="w-[30px]" />
          <div
            className={`overflow-hidden transition-all font-sans text-black ${
              isOpen_ ? "ml-3" : "w-0 h-0"
            }`}
          >
            Setting
          </div>
        </div>
        <div
          className={`flex flex-row w-full items-center py-2 px-3 rounded-lg cursor-pointer hover:font-bold ${
            "support" == active ? "bg-gray-200 font-bold" : "hover:bg-gray-100"
          }`}
          onClick={() => navigate("/support")}
        >
          <img src={support} className="w-[30px]" />
          <div
            className={`overflow-hidden transition-all font-sans text-black ${
              isOpen_ ? "ml-3" : "w-0 h-0"
            }`}
          >
            Support
          </div>
        </div>
      </div>
    </div>
  );
};

export default SideBar;
